import { SettingsCustomFormFieldData } from '../../../models/settings/settings-custom-form-field-data.class';
import { FieldDataInterface } from '../../../models/settings/settings-custom-form-field-data.model';

export class SettingsMultipleTagSelectorV1Field extends SettingsCustomFormFieldData {

    public categoryId: number | null = null;
    // constructor(type:string, field?:FieldDataInterface) {
    //   super(type, field);
    // }

    public serialize(): FieldDataInterface {
        return this._serialize({ category: this.categoryId });
    }

    public deserialize(field: FieldDataInterface): SettingsMultipleTagSelectorV1Field {
        const self = new SettingsMultipleTagSelectorV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
        // Deserialize other properties using class's logic
        self.categoryId = field.options.category;
        return self;
    }

    public update(updateData: Partial<SettingsMultipleTagSelectorV1Field>) : SettingsMultipleTagSelectorV1Field {
        // Create a new instance with the initial data
        const self = new SettingsMultipleTagSelectorV1Field(
            this.type,
            this.position,
            this.id,
            this.label,
            this.mandatory,
            this.active,
        );

        self.categoryId = this.categoryId;

        // Apply any updates provided in updateData
        if (updateData) {
            Object.assign(self, updateData);
            // mark the field as changed    
            self.changed = true;
        }
        
        return self;
    }
}
